import { postSearch } from '@studionand/ada-next/src/api/search';
import { observable, action, computed, toJS } from 'mobx';
import { toSearchResults } from '../utils/mapPages';
import { sortByRanking } from '../shared/utils/sort/';
import onlyDepiPages from './onlyDepiPages';
import onlyDepvPages from './onlyDepvPages';
import CompaniesStore from './modules/Companies';
import PagesStore from './modules/Pages';

class DataStore {
  @observable
  isLoading = false;
  @observable
  searchResult = {};
  @observable
  query = {};
  @observable
  isSearching = false;

  constructor() {
    this.companies = new CompaniesStore({});
    this.pages = new PagesStore({});
  }

  @action.bound
  initialize = async () => {
    this.isLoading = true;
    await this.companies.initialize();
    this.isLoading = false;
  };

  hydrate = snapshot => {
    this.companies.hydrate(snapshot.companies);
    this.pages.hydrate(snapshot.pages);
    this.searchResult = snapshot.searchResult;
    this.query = snapshot.query;
  };

  getSnapshot = () => {
    const { uiStore, ...rest } = this;
    return toJS(rest);
  };

  connectStores = ({ uiStore }) => {
    this.uiStore = uiStore;
  };

  @computed
  get companiesMatchByQuery() {
    return this.companies.asList.filter(c => c.name.toLowerCase().includes(this.query.toLowerCase())).map(c => c.toFilterEntry());
  }

  @computed
  get searchResults() {
    return this.searchResult.results
      ? this.searchResult.results
          .map(toSearchResults)
          .filter(onlyDepiPages)
          .sort(sortByRanking)
      : [];
  }

  @computed
  get searchResultsDepv() {
    return this.searchResult.results
      ? this.searchResult.results
          .map(toSearchResults)
          .filter(onlyDepvPages)
          .sort(sortByRanking)
      : [];
  }

  @action.bound
  async search(query) {
    this.isSearching = true;
    const response = await postSearch(query, ['pages'], 100);
    this.isSearching = false;
    this.searchResult = response.data;
    this.query = query;
    return response.data;
  }
}

export default DataStore;
